const attachmentFilesEquipmentModelsBtn = {
  label: 'ADD'
};

export default attachmentFilesEquipmentModelsBtn;
